import { createAction } from '@reduxjs/toolkit';
import { AppShape } from './model';
import { Settings } from '../../api';
import { User } from '@myua/api/dist/types';

export const main = createAction('al/app/main');

export const initialized = createAction<void, 'al/app/initialized'>('al/app/initialized');

export const userLoaded = createAction<{ user: User }, 'al/app/userLoaded'>('al/app/userLoaded');

export const resetFilters = createAction<{ preserveSearch: boolean }, 'al/app/resetFilters'>(
  'al/app/resetFilters',
);

export const downloadStarted = createAction<{ url: string }, 'al/app/downloadStarted'>(
  'al/app/downloadStarted',
);

export const sidebarExpandedChanged = createAction<{
  sidebarExpanded: AppShape['sidebarExpanded'];
}>('al/app/sidebarExpandedChanged');

export const sidebarWidthChanged = createAction<{
  sidebarWidth: AppShape['sidebarWidth'];
}>('al/app/sidebarWidthChanged');

export const setSidebarDragging = createAction<{
  sidebarDragging: AppShape['sidebarDragging'];
}>('al/app/setSidebarDragging');

export const settingsLoaded = createAction<{ settings: Settings }>('al/app/settingsLoaded');

export const slowNetworkChanged = createAction<{ slow: AppShape['slowNetwork'] }>(
  'al/app/slowNetworkChanged',
);
